<template>
  <div class="container">
    <Step :active-step="2">
      <template slot="step">
        SATIŞ BİLGİLERİ
      </template>
      <template slot="nextStep">
        Sonraki Adım: Ürün Özellikleri
      </template>
    </Step>
    <section>
      <div class="header">
        Satış Bilgilerini Giriniz
      </div>
      <form
        @submit.prevent="onNextStep"
      >
        <template v-for="(row, i) in getRows">
          <div
            :key="i"
            class="item-container"
            :class="{'exist': formData.productVarianters[i].exist}"
          >
            <div
              class="item-header"
              v-if="getVarianter"
            >
              <div class="row">
                <label class="label">
                  {{ i + 1 }}. {{ getVarianter.name }}
                </label>
                <div class="item-content-group">
                  <div class="content-input">
                    <DynamicInput
                      :attr="getVarianterAttributes(getVarianter, i)"
                      :index="i"
                      :class="{'is-invalid' : errors.has(`${getVarianter.props.name}${i}`), 'form-control': getVarianter.className}"
                      v-validate="getVarianter.validation"
                      data-vv-validate-on="change|input"
                      v-model="formData.productVarianters[i].attrs[getVarianter.id]"
                      v-readonly
                    />
                    <div class="invalid-feedback">
                      {{ errors.first(`${getVarianter.props.name}${i}`) }}
                    </div>
                  </div>
                  <div class="content-button">
                    <button
                      class="btn btn-secondary"
                      type="button"
                      @click="removeVarianter(i)"
                    >
                      SİL
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="item-collapse"
              :class="{'show': !getVarianter || formData.productVarianters[i].attrs[getVarianter.id]}"
            >
              <div class="wrapper">
                <div class="row">
                  <template v-if="getVarianters.length > 0">
                    <div
                      class="column"
                      v-for="(varianter, k) in getVarianters"
                      :key="k"
                    >
                      <div class="form-group">
                        <label class="label">
                          {{ varianter.name }}
                          <span
                            class="require"
                            v-if="varianter.validation.required"
                          >
                            *
                          </span>
                        </label>
                        <div>
                          <DynamicInput
                            :attr="getVarianterAttributes(varianter, i)"
                            :index="i"
                            :class="{'is-invalid' : errors.has(varianter.props.name), 'form-control': varianter.className}"
                            v-validate="varianter.validation"
                            data-vv-validate-on="change|input"
                            v-model="formData.productVarianters[i].attrs[varianter.id]"
                          />
                          <div class="invalid-feedback">
                            {{ errors.first(varianter.props.name) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>

                  <div class="column">
                    <div class="form-group">
                      <label class="label">
                        {{ $t('singleProduct.productSaleInfo.labels.barcode') }}
                        <span class="required">
                          *
                        </span>
                      </label>
                      <div>
                        <input
                          type="text"
                          :name="'barcode' + i"
                          v-validate="{required: true, existsArray: [formData.productVarianters, 'barcode', i], validBarcode: '^[A-Za-zÇçŞşİĞğÜüÖöı0-9_.-]*$', max: 40}"
                          data-vv-validate-on="change|input"
                          v-model="formData.productVarianters[i].barcode"
                          class="form-control"
                          :data-vv-as="$t('singleProduct.productSaleInfo.placeholders.barcode')"
                          :class="{'is-invalid' : errors.has('barcode' + i)}"
                          autocomplete="off"
                          v-readonly
                        >
                        <div
                          class="invalid-feedback"
                          v-html="errors.first('barcode' + i)"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="form-group">
                      <label class="label">
                        {{ $t('singleProduct.productSaleInfo.labels.stockCode') }}
                      </label>
                      <div>
                        <input
                          type="text"
                          :name="'stockCode' + i"
                          data-vv-validate-on="change|input"
                          v-model="formData.productVarianters[i].stockCode"
                          class="form-control"
                          autocomplete="off"
                          v-readonly
                        >
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="form-group">
                      <label class="label">
                        {{ $t('singleProduct.productSaleInfo.labels.listPrice') }}
                        <span class="required">
                          *
                        </span>
                      </label>
                      <div>
                        <GInputPrice
                          :name="'listPrice' + i"
                          v-validate="{ required: true }"
                          data-vv-validate-on="change|input"
                          v-model="formData.productVarianters[i].listPrice"
                          :data-vv-as="$t('singleProduct.productSaleInfo.placeholders.listPrice')"
                          :class="{'is-invalid' : errors.has('listPrice' + i)}"
                          @focus="setCaretPosition"
                          v-readonly
                        />
                        <div class="invalid-feedback">
                          {{ errors.first('listPrice' + i) }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="form-group">
                      <label class="label">
                        {{ $t('singleProduct.productSaleInfo.labels.salePrice') }}
                        <span class="required">
                          *
                        </span>
                      </label>
                      <div>
                        <GInputPrice
                          :name="'salePrice' + i"
                          v-validate="{ required: true, isLth: formData.productVarianters[i].listPrice }"
                          data-vv-validate-on="change|input"
                          v-model="formData.productVarianters[i].salePrice"
                          :data-vv-as="$t('singleProduct.productSaleInfo.placeholders.salePrice')"
                          :class="{'is-invalid' : errors.has('salePrice' + i)}"
                          @focus="setCaretPosition"
                          v-readonly
                        />
                        <div class="invalid-feedback">
                          {{ errors.first('salePrice' + i) }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="form-group">
                      <label class="label">
                        {{ $t('singleProduct.productSaleInfo.labels.vatRate') }}
                        <span class="required">
                          *
                        </span>
                      </label>
                      <div>
                        <Select
                          v-model="formData.productVarianters[i].vatRate"
                          :name="'vatRate' + i"
                          :data-vv-as="$t('singleProduct.productSaleInfo.placeholders.vatRate')"
                          v-validate="{ requiredSelect: true }"
                          :class="{'is-invalid' : errors.has('vatRate' + i)}"
                          data-vv-validate-on="change|input"
                          :options="vatRateOptions"
                        />
                        <div class="invalid-feedback">
                          {{ errors.first('vatRate' + i) }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="form-group">
                      <label class="label">
                        {{ $t('singleProduct.productSaleInfo.labels.stockCount') }}
                        <span class="required">
                          *
                        </span>
                      </label>
                      <div>
                        <GInputQuantity
                          :name="'quantity' + i"
                          v-validate="{ required: true, configMax: true}"
                          data-vv-validate-on="change|input"
                          v-model="formData.productVarianters[i].quantity"
                          :data-vv-as="$t('singleProduct.productSaleInfo.placeholders.stockCount')"
                          :class="{'is-invalid' : errors.has('quantity' + i)}"
                        />
                        <div class="invalid-feedback">
                          {{ errors.first('quantity' + i) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-control-information">
                  <b>Barkod:</b> Trendyol sistemine yeni bir ürün eklemek için ürünlerinize ait barkodları
                  girmeniz ya da ürününüze ait barkod yoksa kendiniz oluşturmanız gerekmektedir.
                </div>
                <div class="form-control-information">
                  <b>Satıcı Stok Kodu:</b> Ürünleri kendi stoklarınızda tanımak için kullanabileceğiniz koddur. Zorunlu alan değildir.
                </div>
                <Alert
                  variant="danger"
                  v-if="formData.productVarianters[i].exist"
                >
                  Bu ürün,
                  <span
                    class="link"
                    @click="backToList(formData.productVarianters[i].barcode)"
                  >
                    <b>ürün listenizde</b>
                  </span>
                  bulunmaktadır!
                </Alert>
              </div>
            </div>
          </div>
        </template>
      </form>
    </section>
    <section>
      <div
        class="btn-container"
        v-if="getVarianter && getVarianter.props.options.length > 1"
      >
        <button
          @click="addVarianter"
          class="btn btn-success text-uppercase"
        >
          YENİ {{ getVarianter.name }} EKLE
        </button>
      </div>
    </section>
    <div class="button-wrapper">
      <button
        type="button"
        class="btn btn-secondary"
        @click="onPrevStep"
      >
        GERİ DÖN
      </button>
      <button
        type="button"
        class="btn btn-trendyol"
        @click="onNextStep"
      >
        DEVAM ET
      </button>
    </div>
    <PopupConfirmProduct
      :show="showProductExists"
      :product="productItem"
      :index="productItemIndex"
      :badge-prices="badgePrices"
      @close="closeProductExistsSuccess"
      @removeProductVarianter="removeVarianter"
      @onSuccess="onSuccessProductExistsSuccess"
    />
    <PopupProductSuccess
      :show="showProductSuccess"
      :barcode="'123123'"
      @close="closeProductSuccess"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Step from './Components/Step';
import DynamicInput from './Components/DynamicInput';
import InputMask from '@/directives/InputMask';
import service from '@/services/singleProduct';
import mobile from '@/utils/mobile';
import PopupConfirmProduct from './Popups/PopupConfirmProduct';
import setCaretPosition from '@/mixins/setCaretPosition';
import Alert from '@/components/Alert';
import PopupProductSuccess from './Popups/PopupProductSuccess';
import Select from '@/components/Select';
import GInputPrice from '@trendyol-js/grace/core/GInputPrice';
import GInputQuantity from '@/components/GInputQuantity';

export default {
  name: 'ProductInfo',
  components: {
    GInputQuantity,
    PopupProductSuccess,
    Alert,
    PopupConfirmProduct,
    Step,
    DynamicInput,
    Select,
    GInputPrice,
  },
  directives: {
    mask: InputMask,
  },
  data () {
    return {
      formData: {},
      badgePrices: {},
      vatRateOptions: [
        {
          label: '%0',
          value: 0,
        },
        {
          label: '%1',
          value: 1,
        },
        {
          label: '%10',
          value: 10,
        },
        {
          label: '%20',
          value: 20,
        },
      ],
      showProductExists: false,
      showProductSuccess: false,
      productItem: {},
      productItemIndex: null,
    };
  },
  computed: {
    ...mapGetters({
      getFormData: 'singleProduct/getFormData',
      getVarianters: 'singleProduct/getVarianters',
      getVarianter: 'singleProduct/getVarianter',
    }),
    getRows () {
      return this.formData.productVarianters;
    },
  },
  mixins: [setCaretPosition],
  methods: {
    ...mapActions({
      setFormData: 'singleProduct/setFormData',
    }),
    getVarianterAttributes (varianter, rowIndex) {
      if (!varianter.props.options || varianter.props.options.length === 0) {
        return varianter;
      }
      const attr = JSON.parse(JSON.stringify(varianter));
      const selectedOptionVarianters = [];
      for (let i = 0; i < this.getRows.length; i += 1) {
        if (i !== rowIndex && this.formData.productVarianters[i].attrs[varianter.id]) {
          selectedOptionVarianters.push(this.formData.productVarianters[i].attrs[varianter.id].id);
        }
      }
      attr.props.options = attr.props.options.filter(item => selectedOptionVarianters.indexOf(item.id) === -1);
      return attr;
    },
    async validate () {
      const result = await this.$validator.validateAll();
      if (result) {
        try {
          this.badgePrices = await service.getBadgePricesById(this.formData.productVarianters[0].id);
          await this.productIsExists();
        } catch (e) {
          this.setFormData(this.formData);
          return true;
        }
      }
      return false;
    },
    async addVarianter () {
      const isValid = await this.validate();
      if (isValid) {
        this.formData.productVarianters.push({
          ...this.formData.productVarianters[0],
          barcode: '',
          attrs: {},
        });
      }
    },
    removeVarianter (i) {
      if (this.formData.productVarianters.length > 1) {
        this.$delete(this.formData.productVarianters, i);
      } else {
        this.$set(this.formData, 'productVarianters', [{ attrs: {} }]);
      }
    },
    async getProductViaBarcode (barcode) {
      const response = await service.getByBarcode(barcode, {
        hideErrorMessage: true,
      });
      return response;
    },
    async productIsExists () {
      const varianters = this.formData.productVarianters;
      const varianterIndex = varianters.length - 1;
      const varianter = varianters[varianterIndex];
      this.$set(this.formData.productVarianters[varianterIndex], 'exist', false);
      this.showProductExists = false;

      // eslint-disable-next-line no-useless-catch
      try {
        const products = await this.getProductViaBarcode(varianter.barcode);
        const productItem = products.content[0];
        if (!productItem.exist) {
          productItem.dataAttributes = productItem.productAttributes.filter(attr => ['renk', 'beden'].indexOf(attr.name.toLowerCase()) > -1);
          productItem.image = `${this.$root.cdnUrl}assets/default.jpg`;
          productItem.productImages = productItem.images.map(item => ({
            url: item.originalImageUrl,
          }));
          if (productItem.images[0]) {
            const ext = productItem.images[0].thumbnailUrl.split('.').pop();
            productItem.image = productItem.images[0].thumbnailUrl.search('_org_icon') < 0 ? productItem.images[0].thumbnailUrl.replace(`.${ext}`, `_org_icon.${ext}`) : productItem.images[0].thumbnailUrl;
          }

          this.productItem = { ...productItem, ...varianter };
          this.productItemIndex = varianterIndex;
          this.showProductExists = true;
        } else {
          this.$set(this.formData.productVarianters[varianterIndex], 'exist', true);
        }
      } catch (e) {
        throw e;
      }
    },
    async getBadgePricesById (productId) {
      this.badgePrices = await service.getBadgePricesById(productId);
    },
    onPrevStep () {
      this.$router.push({
        name: 'ProductInfo',
      });
    },
    async onNextStep () {
      const isValid = await this.validate();
      if (isValid) {
        this.$router.push({
          name: 'ProductProperty',
        });
        this.$root.trackEvent({
          eventCategory: 'MobileAppListing',
          eventAction: 'ÜrünListesiDropdownMenüAçanlar',
          eventLabel: 'ÜrünListesiDropdownMenüTekilÜrünEkleme2.adim',
        });
      }
    },
    closeProductExistsSuccess () {
      this.showProductExists = false;
    },
    onSuccessProductExistsSuccess () {
      this.showProductSuccess = true;
    },
    closeProductSuccess () {
      this.showProductSuccess = false;
    },
    backToList (barcode) {
      mobile.navigationNavigate({
        pageName: 'Product',
        params: { reload: Date.now(), barcode },
      });
    },
  },
  async created () {
    this.formData = this.getFormData;
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
  .form-control-information {
    font-size: 14px;
    b {
      text-decoration: underline;
    }
    &.require {
      font-weight: normal;
      color: #ff5043;
    }
  }
  ::v-deep .g-input .body .g-field-wrapper .content {
    border-radius: 4px;
    border: solid 1px #dee0eb;
    height: 40px;
    input {
      font-size: 1rem !important;
    }
  }
  .item-container{
    border-radius: 6px;
    border: 1px solid #d5d9e1;
    background-color: #ffffff;
    padding: 20px;
    margin-bottom: 20px;

    &.exist{
      border-color: #ff5043;
    }

    .item-header{
      position: relative;
      .invalid-feedback{
        position: absolute;
        bottom: -2px;
        transform: translateY(100%);
      }
    }
    .item-content-group {
      display: flex;
      .content-input {
        width: 100%;
      }
      .content-button {
        padding-left: 10px;
        .btn {
          padding: 12px 15px;
        }
      }
    }
    .item-collapse{
      max-height: 0;
      overflow: hidden;
      transition: max-height .5s ease;

      &.show{
        max-height: 700px;
        overflow: initial;
      }
      .wrapper{
        display: block;
        .column {
          margin-bottom: 10px;
        }
      }
    }
  }
</style>
